import {
  TopClimbersResponse,
  TopClimbersResponseSchema,
  GameweeksWithVotesResponse,
  GameweeksWithVotesResponseSchema,
} from '@/types/gameweekLeaderboard';
import { apiRequest } from './client';

const PROFILES_BASE = '/api/v1/profiles';
const GAMEWEEKS_BASE = '/api/v1/gameweeks';

/**
 * Get top climbers for the home page section
 * If gameweekId is not provided, backend returns the last finished GW
 */
export async function getTopClimbers(seasonId: string, gameweekId?: string): Promise<TopClimbersResponse> {
  const query = new URLSearchParams();
  query.set('season_id', seasonId);
  if (gameweekId) query.set('gameweek_id', gameweekId);
  const qs = query.toString();
  const url = `${PROFILES_BASE}/top-climbers?${qs}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return TopClimbersResponseSchema.parse(res);
}

/**
 * Get list of gameweeks that have at least one vote (for dropdown filter)
 */
export async function getGameweeksWithVotes(seasonId: string): Promise<GameweeksWithVotesResponse> {
  const url = `${GAMEWEEKS_BASE}/with-votes?season_id=${seasonId}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return GameweeksWithVotesResponseSchema.parse(res);
}
